module.exports = __webpack_public_path__ + "img/182.82ec8f3c.jpg";